var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"Modal",attrs:{"buttons":['cancel'],"extraLarge":"","title":"Arquivos"}},[_c('Form',{ref:"Form",attrs:{"additionals":_vm.additionals,"arquivos":_vm.arquivos,"item":_vm.item,"solicitacao":_vm.model},on:{"arquivos-atualizados":_vm.handleArquivosAtualizados,"arquivos-preparados":_vm.handleArquivosPreparados}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }